import React, { useEffect, useState } from 'react'
import './AdminLeagueList.css'
import { NavLink } from 'react-router-dom'
import AdminNavigation from './AdminNavigation'
//import RostersDatabaseTable from '../../shared/components/RostersDatabaseTable'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminArchivedLeagueList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [teamId, setTeamId] = useState('')
	const [currentTeam, setCurrentTeam] = useState()
	const [showConfirmMoveToCurrentModal, setShowConfirmMoveToCurrentModal] =
		useState(false)
	const [teamToCurrent, setTeamToCurrent] = useState()
	const [loadedArchivedTeams, setLoadedArchivedTeams] = useState()

	//No dependencies means this will only render once, which is what we want
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/teams/archive'
				)
				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedArchivedTeams(responseData.archivedTeams)
				setCurrentTeam(responseData.currentTeam)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setTeamToCurrent(false)
			setIsLoading(false)
		}
		sendRequest()
	}, [teamToCurrent])

	const errorHandler = () => {
		setError(null)
	}

	if (currentTeam) {
		console.log('WE HAVE A CURRENT TEAM')
	} else {
		console.log('THERE ARE NO CURRENT TEAMS!!')
	}

	//******************************************************** */
	//
	//     Archive warning
	//
	//******************************************************** */
	const showMoveToCurrentHandler = (e) => {
		const value = e.target.id
		console.log(loadedArchivedTeams[value]._id)
		setTeamId(loadedArchivedTeams[value]._id)
		setShowConfirmMoveToCurrentModal(true)
	}

	const cancelMoveToCurrentHandler = () => {
		setShowConfirmMoveToCurrentModal(false)
	}

	const confirmMoveToCurrentHandler = async () => {
		setShowConfirmMoveToCurrentModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${teamId}/archiveCurrentToggleTeam`,
				'PATCH'
			)
		} catch (err) {}
		setTeamToCurrent(true)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && (
					<div className='center'>
						<LoadingSpinner />
					</div>
				)}
				<Modal
					show={showConfirmMoveToCurrentModal}
					onCancel={cancelMoveToCurrentHandler}
					header='Are you sure?'
					footerClass='place-item__modal-actions'
					footer={
						<React.Fragment>
							<p className='modalText'>
								Are you sure you wish to move this team to Current status?
							</p>
							<br></br>
							<button
								className='cancelDeleteButtons buttonButton'
								inverse
								style={{ float: 'right' }}
								onClick={cancelMoveToCurrentHandler}
							>
								CANCEL
							</button>
							<button
								className='cancelDeleteButtons buttonButton'
								danger
								onClick={confirmMoveToCurrentHandler}
							>
								MOVE TO CURRENT
							</button>
						</React.Fragment>
					}
				></Modal>
				{!isLoading && !loadedArchivedTeams && (
					<div className='AdminLeagues'>
						<AdminNavigation />
						<h1>No Archived Teams!</h1>
					</div>
				)}
				{!isLoading && loadedArchivedTeams && (
					<div className='AdminLeagues'>
						<AdminNavigation />
						<h1>Archived Teams</h1>
						<h5
							style={{
								textAlign: 'center',
								marginBottom: '0.5rem',
								fontSize: 'small',
							}}
						>
							For individual team sites, you can only have ONE Current Team.
						</h5>
						<h5
							style={{
								textAlign: 'center',
								marginBottom: '0.5rem',
								fontSize: 'small',
							}}
						>
							You cannot move an Archived team to Current if there's already a
							Current team.
						</h5>
						<table id='teamList'>
							<thead>
								<tr>
									<th>Team Name</th>
									<th>Year</th>
									{!currentTeam && <th></th>}
								</tr>
							</thead>
							<tbody>
								{loadedArchivedTeams.map((team, key) => {
									return (
										<tr key={key}>
											<td>{team.teamName}</td>
											<td>{team.year}</td>
											{!currentTeam && (
												<td>
													<button
														className='buttonButton'
														id={key}
														onClick={(e) => showMoveToCurrentHandler(e)}
													>
														Move To Current
													</button>
												</td>
											)}
										</tr>
									)
								})}
							</tbody>
						</table>
					</div>
				)}
			</React.Fragment>
		</div>
	)
}

export default AdminArchivedLeagueList
